import { render, staticRenderFns } from "./MediaMailer.vue?vue&type=template&id=a2181cbe&scoped=true&"
import script from "./MediaMailer.vue?vue&type=script&lang=js&"
export * from "./MediaMailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2181cbe",
  null
  
)

export default component.exports